import { requiredString } from '@wyz/utils';
import { z } from 'zod';

export const criteriaFormSchema = z.object({
  name: requiredString,
});

export const criteriaVisibilityRuleSchema = z.object({
  valueIds: z.array(z.string()),
  automakerGroupIds: z.array(z.string()),
});

// the values of a rule are given by id when they exist, by label otherwise, the API stores their ids
export const criteriaVisibilityRulePayloadSchema = z.object({
  valueIds: z.array(z.string()).optional(),
  values: z
    .array(z.object({ id: z.string().optional(), label: z.string() }))
    .optional(),
  automakerGroupIds: z.array(z.string()),
});

export const RULE_INCOMPLETE_MESSAGE =
  'app.criteria.form.modal.visibility.rule_incomplete';

export const criteriaFormModalSchema = criteriaFormSchema.extend({
  values: z
    .array(
      z.object({
        uid: z.string(),
        id: z.string().optional(),
        label: z.string().min(1),
        default: z.boolean().optional(),
      }),
    )
    // the default value (N/A) is always there, at least one other value is required
    .refine((values) => values.some((value) => !value.default)),
  visible: z.boolean(),
  visibilityRules: z.array(
    z
      .object({
        valueUids: z.array(z.string()),
        automakerGroupIds: z.array(z.string()),
      })
      .refine(
        // an empty row is ignored, a partially filled one is invalid
        (rule) =>
          (rule.valueUids.length === 0) ===
          (rule.automakerGroupIds.length === 0),
        { message: RULE_INCOMPLETE_MESSAGE, path: ['valueUids'] },
      ),
  ),
});

export const criteriaPayloadSchema = criteriaFormSchema.extend({
  visible: z.boolean(),
  values: z.array(
    z.object({
      id: z.string().optional(),
      label: z.string(),
    }),
  ),
  visibilityRules: z.array(criteriaVisibilityRulePayloadSchema).optional(),
});
export const criteriaSchema = criteriaFormSchema.extend({
  id: z.string(),
  translatedName: z.string().nullable(),
  code: z.enum(['AUTOMAKER_GROUP', 'COUNTRY']).nullish(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
  values: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      default: z.boolean(),
      available: z.boolean().optional(),
    }),
  ),
  visibilityRules: z.array(criteriaVisibilityRuleSchema).optional(),
  available: z.boolean().optional(),
  isReserved: z.boolean().nullish(),
  visible: z.boolean(),
});

export const criteriaCheckUsageSchema = z.object({
  criteria: z.array(
    z.object({
      criterion: z.string(),
      values: z.array(z.string()),
    }),
  ),
});
